import { useEffect, useState } from "react";
import { Marker, Tooltip, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from 'leaflet';
import { useDispatch, useSelector } from "react-redux";
import '../../styles/Pillars04.css'
import { getIconMarkerCluster } from "./helper";
import MarkerClusterGroup from "react-leaflet-markercluster";
import { zLayers } from "./ControlLayer";
import { useCallback } from "react";




export const LayerPillarsOpn = props => {
    // console.log('LayerPillars04')
    const map = useMap()
    const [mapState, setMapState] = useState({ zoom: map.getZoom(), bounds: map.getBounds() });

    // Подписываемся на события карты для обновления при перемещении/зуме
    useEffect(() => {
        const handleMapChange = () => {
            setMapState({ zoom: map.getZoom(), bounds: map.getBounds() });
        };

        map.on('zoomend', handleMapChange);
        map.on('moveend', handleMapChange);

        return () => {
            map.off('zoomend', handleMapChange);
            map.off('moveend', handleMapChange);
        };
    }, [map]);


    const handleMarkerClick = useCallback((mark) => (e) => {
        map.fire('openPopup', {
            class: 'pillar',
            mark: mark,
        });
    }, [map]);

    // const [openedPopup, setOpenedPopup] = useState(null)
    const { pillarsOpn } = useSelector(
        (state) => state.state.electricityFiltered
    );
    const { opn } = useSelector(
        (state) => state.state.mounted
    );
    const { printing, drawing } = useSelector(
        (state) => state.helper
    );
    // const mounted =  props.viewMounted ? (opn || []) : []

    if (!pillarsOpn) {
        return <></>
    }





    //для усечения маркеров находящихся в невидимой области
    const bounds = printing ? new L.LatLngBounds([printing.bounds.south, printing.bounds.west], [printing.bounds.north, printing.bounds.east]) : mapState.bounds
    const nePixel = map.project(bounds.getNorthEast());
    const swPixel = map.project(bounds.getSouthWest());

    //для позиционирования надписей
    // const posBounds = printing && printing.posBounds ? new L.LatLngBounds([printing.posBounds.south, printing.posBounds.west], [printing.posBounds.north, printing.posBounds.east]) : map.getBounds()
    const posBounds = mapState.bounds

    const posnePixel = map.project(posBounds.getNorthEast());
    const posswPixel = map.project(posBounds.getSouthWest());


    let hosts = pillarsOpn
    hosts = hosts.map((mark, index) => {



        const markPixel = map.project(mark.coords)
        // if (!mark.accounting) return null

        //Отбрасываем маркеры которые выходят за рамки видимой области
        if ((markPixel.x < swPixel.x) || (markPixel.x > nePixel.x) || (markPixel.y < nePixel.y) || (markPixel.y > swPixel.y)) return null
        //Если идет печать то отбрасываем маркеры которые выходят за рамки заданной области
        if (printing) {
            if ((markPixel.x < posswPixel.x) || (markPixel.x > posnePixel.x) || (markPixel.y < posnePixel.y) || (markPixel.y > posswPixel.y)) return null
        }

        return mark



    }).filter(f => f)





    const markers = hosts.map((mark, index) => {
        const mount_status = props.viewMounted ? mark.mount_status || 0 : 0
        return (
            <Marker

                position={mark.coords}
                icon={L.divIcon({
                    className: 'pillars-opn-marker',
                    html: `<div class="pillars-opn-marker-text">
                    ${mount_status > 0 ?
                            `
                        <div style='position:absolute; bottom: 0; display:flex; margin-left: -6px; margin-bottom: -6px'>
                        <svg width="36" height="36" viewBox="0 0 100 100">
                            <defs>
                            <radialGradient id="OpnRadialGradient1">
                                <stop offset="0%" stop-color="#ffa000" stop-opacity="0" />
                                <stop offset="10%" stop-color="#ffa000" stop-opacity="0" />
                                <stop offset="70%" stop-color="#ffa000" stop-opacity="0.7" />
                                <stop offset="100%" stop-color="#ffa000" stop-opacity="0" />
                            </radialGradient>
                            <radialGradient id="OpnRadialGradient2">
                                <stop offset="0%" stop-color="#00dd00" stop-opacity="0" />
                                <stop offset="10%" stop-color="#00dd00" stop-opacity="0" />
                                <stop offset="70%" stop-color="#00dd00" stop-opacity="0.7" />
                                <stop offset="100%" stop-color="#00dd00" stop-opacity="0" />
                            </radialGradient>
                            <radialGradient id="OpnRadialGradient3">
                                <stop offset="0%" stop-color="#dd50dd" stop-opacity="0" />
                                <stop offset="10%" stop-color="#dd50dd" stop-opacity="0" />
                                <stop offset="70%" stop-color="#dd50dd" stop-opacity="0.7" />
                                <stop offset="100%" stop-color="#dd50dd" stop-opacity="0" />
                            </radialGradient>
                            <radialGradient id="OpnRadialGradient4">
                                <stop offset="0%" stop-color="#8b008b" stop-opacity="0" />
                                <stop offset="10%" stop-color="#8b008b" stop-opacity="0" />
                                <stop offset="70%" stop-color="#8b008b" stop-opacity="0.7" />
                                <stop offset="100%" stop-color="#8b008b" stop-opacity="0" />
                            </radialGradient>
                            </defs>
                            <circle r="50" cx="50" cy="50" fill="url(#OpnRadialGradient${mount_status})" />
                        </svg>
                        </div>
                    ` : ''
                        }
                    <div style='position:absolute; top: 0; display:flex; margin-left: 0px; margin-bottom: 0px'>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="24" height="24">
                        <!-- Прямоугольный корпус с округлёнными углами -->
                        <rect x="20" y="16" width="24" height="32" rx="4" fill="none" stroke="orange" stroke-width="5" stroke-linecap="round"/>

                        <!-- Диагональная линия -->
                        <line x1="12" y1="44" x2="52" y2="20" stroke="orange" stroke-width="5" stroke-linecap="round"/>

                        <!-- Продолжение диагонали вверх -->
                        <line x1="52" y1="20" x2="52" y2="8" stroke="orange" stroke-width="5" stroke-linecap="round"/>

                        <!-- Продолжение диагонали вниз -->
                        <line x1="12" y1="44" x2="12" y2="56" stroke="orange" stroke-width="5" stroke-linecap="round"/>

                        <!-- Верхний вывод -->
                        <line x1="32" y1="4" x2="32" y2="16" stroke="orange" stroke-width="5" stroke-linecap="round"/>

                        <!-- Нижний вывод -->
                        <line x1="32" y1="48" x2="32" y2="60" stroke="orange" stroke-width="5" stroke-linecap="round"/>
                        </svg>
                        </div>
                    </div>`,
                    iconSize: [24, 24],
                    iconAnchor: [12, 12]


                })}
                key={printing ? `printing_opn_${mark.fid}` : drawing ? `drawing_opn_${mark.fid}` : `opn_${mark.fid}`}
                data={mark.fid}
                type={mark.type}
                pane="otherPane"
                interactive={!drawing?.state}

                eventHandlers={{
                    click: handleMarkerClick(mark)
                }}






            >

                {!drawing &&
                    <Tooltip
                        direction="top"
                        key={`${mark.fid}_tooltip`}
                        offset={[2, -9]}
                        opacity={1}

                    >
                        Комплект ОПН
                    </Tooltip>
                }



            </Marker>



        );
    }).filter(Boolean);

    const createClusterCustomIcon = (cluster) => {
        let type = 'pillarOpn'

        return getIconMarkerCluster(cluster.getAllChildMarkers().length, type)
    };

    return <MarkerClusterGroup
        // key={Date.now()}
        maxClusterRadius={40}
        iconCreateFunction={createClusterCustomIcon}
        removeOutsideVisibleBounds
        zoomToBoundsOnClick={true}
        spiderfyOnEveryZoom={false}
        // animateAddingMarkers
        // animate
        type={'cluster'}
        disableClusteringAtZoom={18}
        clusterPane="otherPane"
        chunkedLoading={true}
        polygonOptions={{ color: "#grey", weight: 1 }}




    >
        {markers}
    </MarkerClusterGroup>



}

